<template>
  <i
    v-on="$listeners"
    :class="getClass"
  />
</template>

<script>
export default {
  name: 'MIcon',
  props: {
    size: { // small | regular | medium | large | blankslate
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
    isPrefixIcon: {
      type: Boolean,
      default: false,
    },
    isSuffixIcon: {
      type: Boolean,
      default: false,
    },
    isDoubleSuffixIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getColor() {
      return this.color && this.size !== 'blankslate' ? ` text-${this.color}` : '';
    },
    getSize() {
      return this.size && this.size !== 'regular' ? ` ic-${this.size}` : '';
    },
    getVariant() {
      return this.variant ? ` ic-${this.variant}` : '';
    },
    getInputIcon() {
      let output = '';
      if (this.isPrefixIcon) {
        output += ' ic-input-prefix';
      }
      if (this.isSuffixIcon || this.isDoubleSuffixIcon) {
        output += ' ic-input-suffix';
        if (this.isDoubleSuffixIcon) {
          output += ' ic-input-suffix--double';
        }
      }
      return output;
    },
    getClass() {
      return `ic${this.getColor}${this.getSize}${this.getVariant}${this.getInputIcon}`;
    },
  },
};
</script>
